import { jsonToQuery } from "../../utils/CoreUtils";
import { doFetch, REQUEST_CONTENT_TYPE, REQUEST_METHODS } from "../fetcher";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // language related apis
  loginAdmin: (data) => doFetch(`/auth/login`, REQUEST_METHODS.POST, data),
  loginOTPVerify: (data) =>
    doFetch(`/auth/otpVerificationForLogin`, REQUEST_METHODS.POST, data, {
      contentType: REQUEST_CONTENT_TYPE.MULTIPART,
    }),

  // forgot password
  generateOtpForForgotPassword: (data) =>
    doFetch(
      `/auth/generateOtpForForgotPassword${jsonToQuery(data)}`,
      REQUEST_METHODS.POST,
      data
    ),
  verifyForgotPasswordOTP: (data) =>
    doFetch(
      `/auth/otpVerificationForForgotPassword${jsonToQuery(data)}`,
      REQUEST_METHODS.POST,
      data
    ),
  resetPassword: (data) =>
    doFetch(
      `/auth/setPasswordForForgotPassword${jsonToQuery(data)}`,
      REQUEST_METHODS.POST,
      data
    ),
  logout: () => doFetch(`/auth/customLogout`, REQUEST_METHODS.POST),
};
